export default function Footer() {
  return (
    <footer id="contact" className="bg-slate-800 text-white">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
          <div>
            <div className="flex items-center mb-4">
              <img
                src="https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/cd01ee5b12e74fec53d91305706c728b.jpeg"
                alt="虹橋株式会社"
                className="h-10 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-gray-400 text-sm mb-8">
              学生一人ひとりの未来を虹のように輝かせる
            </p>
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-teal-500 mt-1"></i>
                <p className="text-gray-300">東京都新宿大久保2-13-4 303</p>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-teal-500"></i>
                <a href="mailto:info@nijihashi.co.jp" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  info@nijihashi.co.jp
                </a>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8">
            <div>
              <h3 className="text-base font-medium mb-4">サービス</h3>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">大学進学支援</a></li>
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">学生後期サービス</a></li>
                <li><a href="#services" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">寮管理</a></li>
                <li><a href="/contact" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">お問い合わせ</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-base font-medium mb-4">グループ校</h3>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><a href="#about" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">恒德職業学校</a></li>
                <li><a href="#about" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">明德職業学校</a></li>
                <li><a href="#about" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">東京こころ日本語学校</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/fc90c2a78ad86dbd6750f83b9dfb8605.jpg"
                alt="Office"
                className="w-full h-48 object-cover object-top rounded-lg"
              />
            </div>

            <div className="text-center lg:text-left">
              <p className="text-2xl font-light leading-tight mb-8" style={{ fontFamily: 'serif' }}>
                共に学生の未来を<br />
                支えていきましょう
              </p>
              <a
                href="/contact"
                className="inline-flex items-center space-x-2 bg-teal-600 text-white px-6 py-3 rounded-lg text-sm hover:bg-teal-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span>お問い合わせはこちら</span>
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-700 text-center">
          <p className="text-lg font-light mb-1" style={{ fontFamily: 'serif' }}>© 虹橋株式会社 2025</p>
          <p className="text-xs text-gray-400">All rights reserved</p>
        </div>
      </div>
    </footer>
  );
}
